@if (pollData) {
    <div [class.smallPollContainer]="small" class="pollContainer">
        <div class="d-flex gap-10 align-items-start">
            <div>
                <h3 class="my-0">{{ pollData.text }}</h3>
                <div class="italic">{{ pollData.description }}</div>
            </div>
        </div>
        @if (pollData.scale && !showResult) {
            @for (question of pollData.questions; track question) {
                <ng-container [ngTemplateOutletContext]="{question:question}"
                              [ngTemplateOutlet]="questionContent"></ng-container>
            }
            @if (!hasTimePassed && !preview && (isParticipant || this.hasCommunityRole(['full_admin']))) {
                <div class="my-20 d-flex flex-space-between align-items-end gap-5">

                    @if (pollData.end_at && isPast(pollData.end_at)) {
                        <div>
                            <span class="textAccent">* This poll is now closed</span>
                        </div>
                    } @else if (pollData.end_at) {
                        <div>
                            <span class="textAccent">* This poll will close {{ pollData.end_at | relativeTime:{maxUnit: 'day'} }}</span>
                        </div>
                    }

                    @if (!showResult) {
                        <button (click)="vote()" [disabled]="!pollVoteValid || voteSending"
                                color="accent" mat-raised-button>
                            {{ pollData.ai_comment_builder ? 'Submit' : voteButtonLabel }}
                            @if (voteSending) {
                                <mat-icon>
                                    <mat-spinner color="accent"></mat-spinner>
                                </mat-icon>
                            }
                        </button>
                    }
                    <!--            <button *ngIf="showResult" mat-raised-button color="accent" (click)="changeVote()">Change vote-->
                    <!--            </button>-->
                </div>
            }
        }
        @if (!pollData.scale || showResult) {
            <div [class.mt-10]="small" [class.mt-20]="!small">
                <mat-stepper #stepper (stepsChanged)="updateSteps($event)"
                             [class.hideheader]="pollData.questions?.length <=1 "
                             [linear]="!showResult" appStepperWatcher
                             class="pollStepper" [class.tickIcon]="showResult">
                    <ng-container>
                        @for (question of pollData.questions; track question) {
                            <!--                        [label]="question.text"-->
                            @if (displayConditionsMet(question)) {
                                <mat-step>
                                    <ng-container [ngTemplateOutletContext]="{question:question}"
                                                  [ngTemplateOutlet]="questionContent"></ng-container>
                                </mat-step>
                            }
                        }
                    </ng-container>
                </mat-stepper>
            </div>
            @if (!hasTimePassed && !preview && (isParticipant || this.hasCommunityRole(['full_admin']))) {
                <div class="my-20 d-flex flex-space-between align-items-end gap-5">
                    @if (pollData.end_at && isPast(pollData.end_at)) {
                        <div>
                            <span class="textAccent">* This poll is now closed</span>
                        </div>
                    } @else if (pollData.end_at) {
                        <div>
                            <span class="textAccent">* This poll will close {{ pollData.end_at | relativeTime:{maxUnit: 'day'} }}</span>
                        </div>
                    }

                    @if (!showResult && steps > 1 && steps !== stepper.selectedIndex + 1) {
                        <button (click)="stepper.next()"
                                [disabled]="!questionPollVoteValid(getQuestion(stepper.selectedIndex))"
                                color="accent" mat-raised-button>
                            Next question
                        </button>
                    }
                    @if (!showResult && steps === stepper.selectedIndex + 1) {
                        <button (click)="vote()"
                                [disabled]="steps !== pollData.questions?.length ? !questionPollVoteValid(getQuestion(stepper.selectedIndex)) : !pollVoteValid"
                                color="accent"
                                mat-raised-button>
                            {{ pollData.ai_comment_builder ? 'Submit' : voteButtonLabel }}
                        </button>
                    }

                    @if (!userToken && showResult && pollData.ai_comment_builder && isParticipant && pollData.post_id && !!pollData?.user_vote?.length) {
                        <button (click)="generateAiSummary(pollData.id, pollData.post_id)"
                                color="accent"
                                mat-raised-button>
                            Re-Submit
                        </button>
                    }

                    <!--            <button *ngIf="showResult" mat-raised-button color="accent" (click)="changeVote()">Change vote-->
                    <!--            </button>-->
                </div>
            }
        }
    </div>
}

<ng-template #questionContent let-question="question">
    <h3>{{ question.text }}</h3>
    @if (question.description) {
        <h5>{{ question.description }}</h5>
    }
    @if (question.type == 'text') {
        <ng-container [ngTemplateOutletContext]="{question}"
                      [ngTemplateOutlet]="freeText"></ng-container>
    } @else if (question.type == 'order') {
        <ng-container [ngTemplateOutletContext]="{question}"
                      [ngTemplateOutlet]="dragDrop"></ng-container>
    } @else if (question.type == 'lists') {
        <ng-container [ngTemplateOutletContext]="{question}"
                      [ngTemplateOutlet]="listDragDrop"></ng-container>
    } @else if (question.type == 'slider') {
        <ng-container [ngTemplateOutletContext]="{question}"
                      [ngTemplateOutlet]="sliders"></ng-container>
    } @else if (question.type == 'click_game' && !showResult) {
        <ng-container [ngTemplateOutletContext]="{question}"
                      [ngTemplateOutlet]="clickGame"></ng-container>
    } @else if (question.type == 'select' || (question.type == 'click_game' && showResult)) {
        <div [class.flex-row]="pollData.scale && !showResult"
             [class.flex-space-around]="pollData.scale && !showResult" [class.gap-10]="pollData.scale">
            @for (option of question.options; track option) {
                <div [class.flex-even]="pollData.scale" [class.mb-10]="small"
                     [class.mb-15]="!small"
                     [ngStyle]="{ width: pollData.scale && !showResult ? 'calc(100%/' + question.options.length + ')' : '' }"
                     class="flex-col gap-5" data-test="calc(100%/' + question.options.length + ');'">
                    <ng-container [ngTemplateOutletContext]="{option, question}"
                                  [ngTemplateOutlet]="question.multiple_choices ? multipleChoice : singleChoice"></ng-container>
                </div>

                @if (showResult && option.is_other_option) {
                    @if (!isParticipant) {
                        <div>
                            <mat-form-field appearance="outline" class="w-100 mt-10"
                                            color="accent">
                                <mat-label>Please Specify</mat-label>
                                <textarea
                                        [value]="option.user_text_response_summary?.sentiment_label? 'Average sentiment ' +  option.user_text_response_summary?.sentiment_label + ' (' + option.user_text_response_summary.total_responses + ' responses)' : 'Not enough responses for sentiment analysis.'"
                                        matInput [disabled]="true" [readonly]="true"
                                        maxlength="255" rows="5"></textarea>
                                <mat-hint>As you have selected '{{ option.text }}' please provide further details
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    } @else if (option.voted_by_user) {
                        <div>
                            <mat-form-field appearance="outline" class="w-100 mt-10"
                                            color="accent">
                                <mat-label>Please Specify</mat-label>
                                <textarea
                                        [value]="option.user_text_response  || 'You did not answer this question.'"
                                        matInput [disabled]="true" [readonly]="true"
                                        maxlength="255" rows="5"></textarea>
                                <mat-hint>As you have selected '{{ option.text }}' please provide further details
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    }
                } @else if (option.is_other_option && question.results?.includes(option.id)) {
                    <mat-form-field appearance="outline" class="w-100 mt-10"
                                    color="accent">
                        <mat-label>Please Specify</mat-label>
                        <textarea required [(ngModel)]="option.freeText" [ngModelOptions]="{standalone: true}"
                                  matInput maxlength="255" rows="5"></textarea>
                        <mat-hint>As you have selected '{{ option.text }}' please provide further details</mat-hint>
                    </mat-form-field>
                }
            }
            @if (question.max_responses && question?.results?.length >= question.max_responses && !preview && !showResult) {
                <small>
                    You can only select {{ question.max_responses }} options. Unselect an option to select another.
                </small>
            }

        </div>
    }

</ng-template>

<ng-template #freeText let-question="question">
    <div class="flex-col gap-10">
        @for (option of question.options; track option) {
            <div>
                @if (showResult) {
                    @if (isParticipant) {
                        <div>
                            <mat-form-field appearance="outline" class="w-100 mt-10"
                                            color="accent">
                                <mat-label>{{ option.text }}</mat-label>
                                <textarea
                                        [value]="option.user_text_response  || 'You did not answer this question.'"
                                        matInput [disabled]="true" [readonly]="true"
                                        maxlength="255" rows="5"></textarea>

                                @if (option.description) {
                                    <mat-hint>{{ option.description }}</mat-hint>
                                }
                            </mat-form-field>
                        </div>
                    } @else {
                        <div>
                            <mat-form-field appearance="outline" class="w-100 mt-10"
                                            color="accent">
                                <mat-label>{{ option.text }}</mat-label>
                                <textarea
                                        [value]="option.user_text_response_summary?.sentiment_label? 'Average sentiment ' +  option.user_text_response_summary?.sentiment_label + ' (' + option.user_text_response_summary.total_responses + ' responses)' : 'Not enough responses for sentiment analysis.'"
                                        matInput [disabled]="true" [readonly]="true"
                                        maxlength="255" rows="5"></textarea>

                                @if (option.description) {
                                    <mat-hint>{{ option.description }}</mat-hint>
                                }
                            </mat-form-field>
                        </div>
                    }
                } @else {
                    <div>
                        <mat-form-field appearance="outline" class="w-100 mt-10"
                                        color="accent">
                            <mat-label>{{ option.text }}</mat-label>
                            <textarea [(ngModel)]="option.freeText" [ngModelOptions]="{standalone: true}"
                                      matInput maxlength="255" rows="5"></textarea>
                            @if (option.description) {
                                <mat-hint>{{ option.description }}</mat-hint>
                            }
                        </mat-form-field>
                    </div>
                }
            </div>
        }
    </div>
</ng-template>
<ng-template #multipleChoice let-option="option" let-question="question">
    <div class="flex-row gap-10">
        <div class="voteBlock">
            @if (showResult) {
                <div class="percentage">{{ getPercentage(option.votes_count, this.pollData.total_votes) }}
                    <br>({{ option.votes_count }} Votes)
                </div>
            }

            <mat-checkbox #opt (change)="setResult(question, 'results', option,true)"
                          [checked]="question.results?.includes(option.id)" [disableRipple]="true"
                          [disabled]="preview || ((question.max_responses && question?.results?.length >= question.max_responses) && !question.results?.includes(option.id))"
                          [hidden]="showResult"
                          [value]="option.id"
                          color="accent">
            </mat-checkbox>

        </div>
        <div (click)="!showResult && opt._onInputClick()" [class.cursorPointer]="!showResult"
             [class.mt-5]="small" [class.showResult]="showResult"
             class="flex-col w-100 option-detail justify-content-center">
            <ng-container [ngTemplateOutletContext]="{
                              count:option.votes_count,
                              text: option.text,
                              description:option.description,
                              checked: question.results?.includes(option.id),
                              showResult,
                              userVoted: pollData.user_vote.includes(option.id)
                          }"
                          [ngTemplateOutlet]="resultBar"></ng-container>
        </div>
    </div>
    @if ((question.results?.includes(option.id) || showResult) && option.nested_options.length > 0) {
        <ng-container
                [ngTemplateOutletContext]="{option}"
                [ngTemplateOutlet]="nestedOptions">
        </ng-container>
    }
</ng-template>

<ng-template #singleChoice let-option="option" let-question="question">
    <div [ngClass]="pollData.scale && !showResult? 'flex-reverse-col': 'flex-row gap-10'">
        <div class="voteBlock">
            <mat-radio-button #opt (change)="setResult(question, 'results',option,false)"
                              [checked]="question.results?.includes(option.id)"
                              [disableRipple]="true"
                              [disabled]="preview"
                              [hidden]="showResult"
                              [name]="'nestedPollOption-' + question.id" [value]="option.id"
                              color="accent">
            </mat-radio-button>

        </div>
        <div (click)="!showResult && opt._inputElement.nativeElement.click()" [class.cursorPointer]="!showResult"
             [class.flex-col]="pollData.scale" [class.mt-5]="small"
             [class.showResult]="showResult" [class.text-center]="pollData.scale && !showResult"
             class="flex-col w-100 option-detail justify-content-center">
            <ng-container [ngTemplateOutletContext]="{
                              count:option.votes_count,
                              text: option.text,
                              description:option.description,
                              checked: question.results?.includes(option.id),
                              showResult,
                              userVoted: pollData.user_vote.includes(option.id)
                          }"
                          [ngTemplateOutlet]="resultBar"></ng-container>
        </div>
    </div>
    @if ((question.results?.includes(option.id) || showResult) && option.nested_options.length > 0) {
        <ng-container
                [ngTemplateOutletContext]="{option}"
                [ngTemplateOutlet]="nestedOptions">
        </ng-container>
    }
</ng-template>

<ng-template #resultBar let-checked="checked" let-count="count" let-description="description"
             let-showResult="showResult"
             let-text="text" let-userVoted="userVoted">
    <div [class.checked]="checked" [class.showResult]="showResult" [class.userVoted]="userVoted" class="bar-container">
        <div [@barWidthAnimation]="{value: '*', params: {width: showResult ? getPercentage(count|| 0, this.pollData.total_votes) : '0%'}}"
             class="bar"></div>
        <div class="vote-details">
            <div [appTruncatedTooltip]="text">{{ text }}</div>
            @if (description) {
                <div [appTruncatedTooltip]="description" class="italic description">{{ description }}
                </div>
            }
        </div>
        @if (showResult) {
            <div class="percentage">{{ getPercentage(count, this.pollData.total_votes) }}
                (<span [countUp]="count" [duration]="500"> {{ count }} </span>&nbsp;votes)
            </div>
        }
    </div>
</ng-template>

<ng-template #nestedOptions let-option="option">
    <div class="ml-20 my-10 gap-5 flex-col">
        <h4 class="m-0">{{ option.nested_question_title }}</h4>
        @for (nestedOption of option.nested_options; track nestedOption) {
            <app-nested-option
                #optionComponent
                (setResult)="setResult(option, 'nestedResults', nestedOption,$event)"
                [nestedOption]="nestedOption"
                [option]="option"
                [preview]="preview"
                [showResult]="showResult"
            >
                <div (click)="!showResult && optionComponent.click()" [class.cursorPointer]="!showResult"
                     [class.mt-5]="small" [class.showResult]="showResult"
                     class="flex-col w-100 option-detail justify-content-center">
                    <ng-container [ngTemplateOutletContext]="{
                                      count:nestedOption.votes_count,
                                      text: nestedOption.text,
                                      description:nestedOption.description,
                                      checked: option?.nestedResults?.includes(nestedOption.id),
                                      showResult,
                                      userVoted: pollData.user_vote.includes(nestedOption.id)
                                  }" [ngTemplateOutlet]="resultBar"></ng-container>
                </div>
            </app-nested-option>
        }
        @if (option.max_nested_responses && option.nested_multiple_choices && option?.nestedResults?.length >= option.max_nested_responses && !preview && !showResult) {
            <small>
                You can only select {{ option.max_nested_responses }} options. Unselect an option to select another.
            </small>
        }
    </div>
</ng-template>

<ng-template #sliders let-question="question">
    <div class="flex-col gap-10">
        @for (option of question.options; track option) {
            <div>
                <div class="flex-col">
                    <p class="m-0">{{ option.text }}</p>
                    @if (option.description) {
                        <p class="m-0">{{ option.description }}</p>
                    }
                </div>
                @if (showResult) {
                    <div class="bar-container userVoted checked showResult">
                        <div [@barWidthAnimation]="{value: '*', params: {width: getPercentage(option.average_slider_response, option.slider_max)}}"
                             class="bar"></div>
                        <div class="vote-details">
                            <div [appTruncatedTooltip]="option.text">{{ option.text }}</div>
                            @if (option.description) {
                                <div [appTruncatedTooltip]="option.description"
                                     class="italic description">{{ option.description }}
                                </div>
                            }
                        </div>
                        <div class="percentage">Average value {{ option.average_slider_response }}
                            /{{ option.slider_max }}
                            (You voted {{ option.user_slider_response }})
                        </div>
                    </div>
                }
                @if (!showResult) {
                    <div class="d-flex flex-row flex-space-between gap-10">
                        <strong>{{ option.slider_start_label || '' }}</strong>
                        <strong>{{ option.slider_middle_label || '' }}</strong>
                        <strong>{{ option.slider_end_label || '' }}</strong>
                    </div>
                    <div class="px-20">
                        <mat-slider class="w-100" [min]="option.slider_min|| 0" [step]="option.slider_step || 1"
                                    [max]="option.slider_max|| 100" showTickMarks discrete disableRipple
                                    [displayWith]="option.slider_step == 0.1 ?currencySliderFormat: defaultSliderFormat">
                            <input matSliderThumb (valueChange)="setSliderValue(option, $event)">
                        </mat-slider>
                    </div>
                }
            </div>
        }
    </div>
</ng-template>

<ng-template #clickGame let-question="question">
    @if (!question.start) {
        <div class="d-flex flex-row justify-content-center">
            <button color="accent" mat-raised-button (click)="question.start = true">Start Game
            </button>
        </div>
    }
    @if (question.start && !question.end) {
        <div class="clickGameContainer" #clickContainer
             [class.h-fit]="question.disable_animation">
            @for (option of question.options; track option; let i = $index) {
                <app-clickable-shape [shape]="option.shape"
                                     [class.animationPaused]="question.paused"
                                     [class.clickGameAnimation]="!question.disable_animation"
                                     [style.--size]="option.size|| 1"
                                     [style.width]="calculateSVGWidth(question.options.length, clickContainer) + 'px'"
                                     [svgWidth]="calculateSVGWidth(question.options.length, clickContainer)"
                                     [clickCount]="option.click_amount"
                                     [shadowsDisabled]="option.disable_shadows"
                                     [textBackgroundDisabled]="option.disable_text_background"
                                     [style.order]="option.order"
                                     [color]="option.colour|| community?.accent_color_hex || '#ffe1aa'"
                                     [text]="option.text"
                                     (selectOption)="setClickResult(question, 'results',option, question.multiple_choices)"
                                     (pauseAnimation)="pauseAnimation(question)"
                                     (clicked)="clickOption(option)"
                                     (animationiteration)="setRandomValuesForClickGame()"
                                     [popText]="option.description"></app-clickable-shape>
            }
        </div>
    }
    @if (question.end) {
        <div class="d-flex flex-col align-items-center">
            <h3 [innerHTML]="question.end"></h3>
            <div>
                <button color="accent" mat-raised-button (click)="restartGame(question)">Restart Game?</button>
            </div>
        </div>
    }
</ng-template>

<ng-template #dragDrop let-question="question">
    @if (showResult) {
        <div class="flex-col gap-10">
            <p class="m-0">Average Order:</p>
            @for (option of orderOptions(question.options, 'average_order'); track option) {
                <div class="bar-container userVoted checked showResult">
                    <div [@barWidthAnimation]="{value: '*', params: {width: '100%'}}"
                         class="bar"></div>
                    <div class="vote-details">
                        <div [appTruncatedTooltip]="option.text">{{ option.text }}</div>
                        @if (option.description) {
                            <div [appTruncatedTooltip]="option.description"
                                 class="italic description">{{ option.description }}
                            </div>
                        }
                    </div>
                    <div class="percentage">
                        (<span [countUp]="option.votes_count" [duration]="500"> {{ option.votes_count }} </span>&nbsp;votes)
                    </div>
                </div>
            }
        </div>
        <div class="flex-col gap-10 mt-15">
            <p class="m-0">Your Order:</p>
            @for (option of orderOptions(question.options, 'user_order'); track option) {
                <div class="bar-container userVoted checked showResult">
                    <div [@barWidthAnimation]="{value: '*', params: {width: '100%'}}"
                         class="bar"></div>
                    <div class="vote-details">
                        <div [appTruncatedTooltip]="option.text">{{ option.text }}</div>
                        @if (option.description) {
                            <div [appTruncatedTooltip]="option.description"
                                 class="italic description">{{ option.description }}
                            </div>
                        }
                    </div>
                    <div class="percentage"> (<span [countUp]="option.votes_count"
                                                    [duration]="500"> {{ option.votes_count }} </span>&nbsp;votes)
                    </div>
                </div>
            }
        </div>
    }
    @if (!showResult) {
        <div class="flex-row gap-10">
            <div class="drag-container">
                <div cdkDropList="cdkDropList"
                     [cdkDropListData]="question.options"
                     class="drag-list"
                     (cdkDropListDropped)="drop($event, question)">
                    @for (option of question.options; track option) {
                        <div class="drag-box" cdkDrag>
                            <div class="flex-col">
                                <p class="m-0">{{ option.text }}</p>
                                @if (option.description) {
                                    <p class="m-0">{{ option.description }}</p>
                                }
                            </div>
                            <div>
                                <mat-icon> drag_handle</mat-icon>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
</ng-template>
<ng-template #listDragDrop let-question="question">
    @if (showResult) {
        @for (option of question.options; track option) {
            @if (!option.hide_in_results) {
                <div class="flex-col gap-10 mt-15">
                    <p class="m-0">{{ option.text }}</p>
                    @if (option.description) {
                        <p class="m-0">{{ option.description }}</p>
                    }
                    @for (nestedOption of option.list_option_stats; track nestedOption) {
                        <div class="bar-container userVoted checked showResult">
                            <div [@barWidthAnimation]="{value: '*', params: {width: showResult ? nestedOption.percentage+'%' : '0%'}}"
                                 class="bar"></div>
                            <div class="vote-details">
                                <div [appTruncatedTooltip]="nestedOption.text">{{ nestedOption.text }}</div>
                                @if (nestedOption.description) {
                                    <div [appTruncatedTooltip]="nestedOption.description"
                                         class="italic description">{{ nestedOption.description }}
                                    </div>
                                }
                            </div>
                            <div class="percentage">
                                (<span [countUp]="nestedOption.votes_count"
                                       [duration]="500"> {{ nestedOption.votes_count }} </span>&nbsp;votes)
                                @if (nestedOption.selected) {
                                    (Your Vote)
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        }
    }
    @if (!showResult) {
        <div class="flex-row gap-10 flex-mobile-col" [class.multipleLists]="question.options.length > 5">
            @for (option of question.options; track option) {
                <div class="drag-container">
                    <p class="m-0">{{ option.text }}</p>
                    @if (option.description) {
                        <p class="m-0">{{ option.description }}</p>
                    }
                    <div cdkDropList
                         [cdkDropListData]="option.nested_options" class="drag-list"
                         [cdkDropListConnectedTo]="connectedDropLists"
                         (cdkDropListDropped)="dropList($event)">
                        @for (nestedOption of option.nested_options; track nestedOption.id) {
                            <div class="drag-box" cdkDrag
                                 [cdkDragData]="nestedOption">
                                <div class="flex-col">
                                    <p class="m-0">{{ nestedOption.text }}</p>
                                    @if (nestedOption.description) {
                                        <p class="m-0">{{ nestedOption.description }}</p>
                                    }
                                </div>
                                <div>
                                    <mat-icon> drag_handle</mat-icon>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
        <div class="flex-col">
            @for (option of question.options; track option) {
                @if (option.slider_max != null && option.nested_options.length > option.slider_max) {
                    <small class="errorMsg">
                        Maximum items allowed for the list "{{ option.text }}" is {{ option.slider_max }} you currently
                        have {{ option.nested_options.length }}</small>
                }
                @if (option.slider_min != null && option.nested_options.length < option.slider_min) {
                    <small class="errorMsg">
                        Minimum items allowed for the list "{{ option.text }}" is {{ option.slider_min }} you currently
                        have {{ option.nested_options.length }}</small>
                }
            }
        </div>
    }
</ng-template>
